var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOffers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 20,
    cy: 20,
    r: 20
  }), /*#__PURE__*/React.createElement("g", {
    id: "icons/cart"
  }, /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/shopping-cart"
  }, /*#__PURE__*/React.createElement("g", {
    id: "shopping-cart"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10 10H11.74C12.82 10 13.67 10.93 13.58 12L12.75 21.96C12.61 23.59 13.9 24.99 15.54 24.99H26.19C27.63 24.99 28.89 23.81 29 22.38L29.54 14.88C29.66 13.22 28.4 11.87 26.73 11.87H13.82",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M24.25 30C24.9404 30 25.5 29.4404 25.5 28.75C25.5 28.0596 24.9404 27.5 24.25 27.5C23.5596 27.5 23 28.0596 23 28.75C23 29.4404 23.5596 30 24.25 30Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M16.25 30C16.9404 30 17.5 29.4404 17.5 28.75C17.5 28.0596 16.9404 27.5 16.25 27.5C15.5596 27.5 15 28.0596 15 28.75C15 29.4404 15.5596 30 16.25 30Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M17 16H29",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOffers);
export default __webpack_public_path__ + "static/media/offers.a87ff80eb8ffccfd72176da65d0a17b2.svg";
export { ForwardRef as ReactComponent };